import React, { useEffect, useRef } from "react";

const FORMSPREE_ENDPOINT = "https://formspree.io/f/myezedqj";

const CSS = `
:root{
  --bg:#FFFBF4; --bg-2:#FFF4E3; --surface:#FFFFFF;
  --ink:#17120E; --ink-2:#5C5248;
  --line:rgba(23,18,14,.10);
  --red:#FF2D2D; --red-deep:#C81E1E;
  --yellow:#FFC400; --yellow-soft:#FFE38A;
  --shadow:0 22px 50px -22px rgba(23,18,14,.28);
  --shadow-sm:0 8px 24px -12px rgba(23,18,14,.22);
  --r:22px;
}
html.dark{
  --bg:#0E0B09; --bg-2:#16110D; --surface:#1B1511;
  --ink:#F8F1E7; --ink-2:#B8AD9E;
  --line:rgba(248,241,231,.12);
  --red:#FF4A4A; --red-deep:#FF2D2D;
  --yellow:#FFD23F; --yellow-soft:#5a4a14;
  --shadow:0 26px 60px -22px rgba(0,0,0,.6);
  --shadow-sm:0 10px 30px -14px rgba(0,0,0,.6);
}
.buildx-root *{margin:0;padding:0;box-sizing:border-box}
html{scroll-behavior:smooth}
.buildx-root{
  background:var(--bg); color:var(--ink);
  font-family:'Plus Jakarta Sans',sans-serif;
  line-height:1.6; overflow-x:hidden;
  transition:background .45s ease,color .45s ease;
  -webkit-font-smoothing:antialiased;
  min-height:100vh;
}
.buildx-root h1,.buildx-root h2,.buildx-root h3,.buildx-root h4,.buildx-root .display{font-family:'Bricolage Grotesque',sans-serif;font-weight:800;line-height:1.02;letter-spacing:-.02em}
.buildx-root .wrap{max-width:1200px;margin:0 auto;padding:0 24px}
.buildx-root a{color:inherit;text-decoration:none}
.buildx-root section{position:relative}
.buildx-root .eyebrow{
  display:inline-flex;align-items:center;gap:9px;
  font-size:.72rem;font-weight:700;letter-spacing:.16em;text-transform:uppercase;
  color:var(--red);padding:7px 14px;border-radius:100px;
  background:color-mix(in srgb,var(--red) 10%,transparent);
  border:1px solid color-mix(in srgb,var(--red) 24%,transparent);
}
.buildx-root .eyebrow .dot{width:7px;height:7px;border-radius:50%;background:var(--red);animation:bx-pulse 1.8s infinite}
@keyframes bx-pulse{0%{box-shadow:0 0 0 0 color-mix(in srgb,var(--red) 70%,transparent)}70%{box-shadow:0 0 0 9px transparent}100%{box-shadow:0 0 0 0 transparent}}

.buildx-root .btn{
  display:inline-flex;align-items:center;justify-content:center;gap:10px;
  font-family:'Plus Jakarta Sans',sans-serif;font-weight:700;font-size:1rem;
  padding:15px 26px;border-radius:100px;border:none;cursor:pointer;
  position:relative;overflow:hidden;transition:transform .25s cubic-bezier(.2,.8,.2,1),box-shadow .25s;
  white-space:nowrap;
}
.buildx-root .btn:active{transform:scale(.97)}
.buildx-root .btn-primary{background:linear-gradient(135deg,var(--red),var(--red-deep));color:#fff;box-shadow:0 14px 30px -10px color-mix(in srgb,var(--red) 65%,transparent)}
.buildx-root .btn-primary:hover{transform:translateY(-3px);box-shadow:0 20px 40px -10px color-mix(in srgb,var(--red) 70%,transparent)}
.buildx-root .btn-primary::after{content:"";position:absolute;top:0;left:-120%;width:60%;height:100%;background:linear-gradient(120deg,transparent,rgba(255,255,255,.45),transparent);transform:skewX(-20deg);transition:left .6s}
.buildx-root .btn-primary:hover::after{left:150%}
.buildx-root .btn-yellow{background:var(--yellow);color:#17120E;box-shadow:0 14px 30px -12px color-mix(in srgb,var(--yellow) 75%,transparent)}
.buildx-root .btn-yellow:hover{transform:translateY(-3px)}
.buildx-root .btn-ghost{background:transparent;color:var(--ink);border:1.5px solid var(--line)}
.buildx-root .btn-ghost:hover{border-color:var(--red);color:var(--red);transform:translateY(-2px)}
.buildx-root .btn-block{width:100%}
.buildx-root .btn-lg{padding:18px 34px;font-size:1.08rem}
.buildx-root .arrow{transition:transform .25s}
.buildx-root .btn:hover .arrow{transform:translateX(4px)}

.buildx-root .announce{background:var(--ink);color:var(--bg);font-size:.85rem;font-weight:600;padding:9px 0}
.buildx-root .announce .wrap{display:flex;align-items:center;justify-content:center;gap:14px;flex-wrap:wrap;text-align:center}
.buildx-root .announce .live{display:inline-flex;align-items:center;gap:7px;color:var(--yellow)}
.buildx-root .announce .live .dot{width:7px;height:7px;border-radius:50%;background:var(--yellow);animation:bx-pulse 1.8s infinite}
.buildx-root .announce a{color:var(--yellow);text-decoration:underline;text-underline-offset:3px}

.buildx-root header{position:sticky;top:0;z-index:50;transition:all .35s}
.buildx-root .nav{display:flex;align-items:center;justify-content:space-between;padding:16px 0}
.buildx-root header.scrolled{background:color-mix(in srgb,var(--bg) 80%,transparent);backdrop-filter:blur(16px);border-bottom:1px solid var(--line)}
.buildx-root .logo{font-family:'Bricolage Grotesque';font-weight:800;font-size:1.5rem;letter-spacing:-.03em;display:flex;align-items:center;gap:2px}
.buildx-root .logo b{color:var(--red)}
.buildx-root .logo .x{display:inline-grid;place-items:center;width:30px;height:30px;margin-left:4px;background:linear-gradient(135deg,var(--red),var(--red-deep));color:#fff;border-radius:9px;font-size:1.1rem;transform:rotate(-6deg)}
.buildx-root .nav-links{display:flex;align-items:center;gap:30px;font-weight:600;font-size:.95rem}
.buildx-root .nav-links a{position:relative;color:var(--ink-2);transition:color .2s}
.buildx-root .nav-links a:hover{color:var(--ink)}
.buildx-root .nav-links a::after{content:"";position:absolute;left:0;bottom:-5px;width:0;height:2px;background:var(--red);transition:width .25s}
.buildx-root .nav-links a:hover::after{width:100%}
.buildx-root .nav-right{display:flex;align-items:center;gap:14px}
.buildx-root .toggle{width:42px;height:42px;border-radius:50%;border:1.5px solid var(--line);background:var(--surface);cursor:pointer;display:grid;place-items:center;color:var(--ink);transition:.25s}
.buildx-root .toggle:hover{border-color:var(--red);transform:rotate(15deg)}
.buildx-root .toggle svg{width:19px;height:19px}
.buildx-root .menu-btn{display:none;background:none;border:none;cursor:pointer;color:var(--ink);width:42px;height:42px}
.buildx-root .mobile-menu{display:none}

.buildx-root .hero{padding:70px 0 60px;position:relative;overflow:hidden}
.buildx-root .blob{position:absolute;border-radius:50%;filter:blur(70px);opacity:.5;z-index:0;pointer-events:none}
.buildx-root .blob.b1{width:520px;height:520px;background:radial-gradient(circle,var(--red),transparent 70%);top:-160px;right:-120px;animation:bx-float1 16s ease-in-out infinite}
.buildx-root .blob.b2{width:460px;height:460px;background:radial-gradient(circle,var(--yellow),transparent 70%);bottom:-180px;left:-120px;animation:bx-float2 19s ease-in-out infinite}
@keyframes bx-float1{50%{transform:translate(-40px,50px) scale(1.1)}}
@keyframes bx-float2{50%{transform:translate(50px,-40px) scale(1.08)}}
.buildx-root .hero-grid{position:relative;z-index:2;display:grid;grid-template-columns:1.05fr .95fr;gap:50px;align-items:center}
.buildx-root .hero h1{font-size:clamp(2.6rem,5.5vw,4.6rem);margin:22px 0 20px}
.buildx-root .hero h1 .hl{color:var(--red);position:relative}
.buildx-root .hero h1 .mark{background:linear-gradient(transparent 60%,var(--yellow) 60%);padding:0 4px}
.buildx-root .hero p.sub{font-size:1.18rem;color:var(--ink-2);max-width:560px;margin-bottom:30px}
.buildx-root .hero-cta{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:26px}
.buildx-root .hero-trust{display:flex;align-items:center;gap:16px;font-size:.9rem;color:var(--ink-2);font-weight:600}
.buildx-root .avatars{display:flex}
.buildx-root .avatars span{width:34px;height:34px;border-radius:50%;border:2.5px solid var(--bg);margin-left:-10px;background:linear-gradient(135deg,var(--red),var(--yellow))}
.buildx-root .avatars span:first-child{margin-left:0}
.buildx-root .stars{color:var(--yellow);letter-spacing:2px}

.buildx-root .ai-visual{position:relative;border-radius:var(--r);overflow:hidden;background:
  radial-gradient(120% 120% at 15% 15%,color-mix(in srgb,var(--yellow) 55%,transparent),transparent 55%),
  radial-gradient(120% 120% at 85% 85%,color-mix(in srgb,var(--red) 55%,transparent),transparent 55%),
  var(--bg-2);
  border:1px solid var(--line);box-shadow:var(--shadow);
  display:flex;align-items:flex-end;min-height:240px}
.buildx-root .ai-visual > img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;z-index:1;display:block}
.buildx-root .ai-visual::before{content:"";position:absolute;inset:0;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.05'/%3E%3C/svg%3E");pointer-events:none;z-index:2}
.buildx-root .ai-tag{position:relative;z-index:3;margin:16px;display:inline-flex;align-items:center;gap:8px;font-size:.72rem;font-weight:700;letter-spacing:.05em;background:color-mix(in srgb,var(--surface) 88%,transparent);backdrop-filter:blur(6px);padding:8px 13px;border-radius:100px;border:1px solid var(--line);color:var(--ink)}
.buildx-root .ai-tag b{color:var(--red);text-transform:uppercase;letter-spacing:.12em;font-size:.66rem}
.buildx-root .price-chip{display:inline-flex;align-items:center;gap:6px;background:color-mix(in srgb,var(--yellow) 22%,transparent);border:1px solid color-mix(in srgb,var(--yellow) 50%,transparent);color:#7a5a00;font-weight:800;font-size:.78rem;letter-spacing:.02em;padding:5px 12px;border-radius:100px;margin-bottom:10px}
.buildx-root .price-chip b{color:var(--ink);font-weight:800}
.buildx-root .hero-visual{position:relative}
.buildx-root .hero-visual .ai-visual{min-height:520px}
.buildx-root .float-chip{position:absolute;z-index:5;background:var(--surface);border:1px solid var(--line);border-radius:16px;padding:13px 16px;box-shadow:var(--shadow-sm);font-weight:700;font-size:.9rem;display:flex;align-items:center;gap:10px}
.buildx-root .float-chip small{display:block;font-weight:500;color:var(--ink-2);font-size:.74rem}
.buildx-root .float-chip .ic{width:34px;height:34px;border-radius:10px;display:grid;place-items:center;font-size:1.1rem}
.buildx-root .fc-1{top:24px;left:-26px;animation:bx-floaty 4s ease-in-out infinite}
.buildx-root .fc-2{bottom:40px;right:-22px;animation:bx-floaty 5s ease-in-out infinite .6s}
.buildx-root .fc-3{bottom:-18px;left:30px;animation:bx-floaty 4.6s ease-in-out infinite .3s}
@keyframes bx-floaty{50%{transform:translateY(-12px)}}

.buildx-root .play-btn{position:absolute;inset:0;margin:auto;width:74px;height:74px;border-radius:50%;background:var(--red);display:grid;place-items:center;z-index:4;box-shadow:0 0 0 0 color-mix(in srgb,var(--red) 60%,transparent);animation:bx-ring 2.4s infinite}
.buildx-root .play-btn svg{width:26px;height:26px;fill:#fff;margin-left:4px}
@keyframes bx-ring{0%{box-shadow:0 0 0 0 color-mix(in srgb,var(--red) 55%,transparent)}70%{box-shadow:0 0 0 24px transparent}100%{box-shadow:0 0 0 0 transparent}}

.buildx-root .ticker{border-top:1px solid var(--line);border-bottom:1px solid var(--line);background:var(--bg-2);overflow:hidden;padding:16px 0}
.buildx-root .ticker-track{display:flex;gap:48px;width:max-content;animation:bx-scroll 26s linear infinite;white-space:nowrap}
.buildx-root .ticker-track span{font-family:'Bricolage Grotesque';font-weight:700;font-size:1.05rem;color:var(--ink-2);display:flex;align-items:center;gap:48px}
.buildx-root .ticker-track span::after{content:"●";color:var(--red);font-size:.6rem}
@keyframes bx-scroll{to{transform:translateX(-50%)}}

.buildx-root .sec{padding:90px 0}
.buildx-root .sec-head{max-width:680px;margin:0 auto 56px;text-align:center}
.buildx-root .sec-head h2{font-size:clamp(2rem,4vw,3.1rem);margin:18px 0 16px}
.buildx-root .sec-head p{font-size:1.12rem;color:var(--ink-2)}
.buildx-root .center{text-align:center}

.buildx-root .stats{background:var(--ink);color:var(--bg);padding:64px 0}
html.dark .buildx-root .stats{background:#070504}
.buildx-root .stats-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:30px}
.buildx-root .stat{text-align:center}
.buildx-root .stat .num{font-family:'Bricolage Grotesque';font-weight:800;font-size:clamp(2.4rem,5vw,3.6rem);background:linear-gradient(135deg,var(--yellow),var(--red));-webkit-background-clip:text;background-clip:text;color:transparent;line-height:1}
.buildx-root .stat .lbl{margin-top:10px;color:color-mix(in srgb,var(--bg) 75%,transparent);font-weight:600;font-size:.95rem}

.buildx-root .problem{background:var(--bg-2)}
.buildx-root .pain-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:20px;max-width:920px;margin:0 auto}
.buildx-root .pain{background:var(--surface);border:1px solid var(--line);border-left:4px solid var(--red);border-radius:16px;padding:24px 26px;display:flex;gap:16px;align-items:flex-start}
.buildx-root .pain .q{font-family:'Bricolage Grotesque';font-weight:800;font-size:1.5rem;color:var(--red);line-height:1}
.buildx-root .pain p{color:var(--ink-2);font-weight:500}
.buildx-root .pain strong{color:var(--ink)}

.buildx-root .shift{background:linear-gradient(135deg,var(--red),var(--red-deep));color:#fff;text-align:center}
.buildx-root .shift .wrap{max-width:840px}
.buildx-root .shift h2{font-size:clamp(2rem,4.4vw,3.2rem);margin-bottom:20px}
.buildx-root .shift h2 .y{color:var(--yellow)}
.buildx-root .shift p{font-size:1.18rem;opacity:.92;margin-bottom:30px}

.buildx-root .svc-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px}
.buildx-root .svc{background:var(--surface);border:1px solid var(--line);border-radius:var(--r);overflow:hidden;transition:.3s;position:relative}
.buildx-root .svc:hover{transform:translateY(-6px);box-shadow:var(--shadow);border-color:color-mix(in srgb,var(--red) 30%,transparent)}
.buildx-root .svc .ai-visual{min-height:360px;border-radius:0;border:none;border-bottom:1px solid var(--line)}
.buildx-root .svc .ai-visual > img{object-position:center center}
.buildx-root .svc:hover .ai-visual{filter:saturate(1.15)}
.buildx-root .svc-body{padding:26px}
.buildx-root .svc-body h3{font-size:1.4rem;margin-bottom:10px}
.buildx-root .svc-body p{color:var(--ink-2);margin-bottom:16px;font-size:.97rem}
.buildx-root .tier-row{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:18px}
.buildx-root .tier{font-size:.78rem;font-weight:700;padding:6px 12px;border-radius:100px;background:var(--bg-2);border:1px solid var(--line)}
.buildx-root .svc-link{display:inline-flex;align-items:center;gap:8px;color:var(--red);font-weight:700;font-size:.95rem}

.buildx-root .kit{background:var(--ink);color:var(--bg);overflow:hidden}
html.dark .buildx-root .kit{background:#070504}
.buildx-root .kit-grid{display:grid;grid-template-columns:1fr 1fr;gap:50px;align-items:center}
.buildx-root .kit .eyebrow{background:color-mix(in srgb,var(--yellow) 16%,transparent);border-color:color-mix(in srgb,var(--yellow) 40%,transparent);color:var(--yellow)}
.buildx-root .kit .eyebrow .dot{background:var(--yellow)}
.buildx-root .kit h2{font-size:clamp(2.1rem,4.4vw,3.3rem);margin:20px 0 18px}
.buildx-root .kit h2 .y{color:var(--yellow)}
.buildx-root .kit p.lead{font-size:1.12rem;color:color-mix(in srgb,var(--bg) 78%,transparent);margin-bottom:26px}
.buildx-root .kit-list{display:grid;grid-template-columns:1fr 1fr;gap:13px 22px;margin-bottom:30px}
.buildx-root .kit-list li{list-style:none;display:flex;gap:11px;align-items:flex-start;font-weight:600;font-size:.97rem}
.buildx-root .tick{flex:none;width:22px;height:22px;border-radius:50%;background:var(--yellow);color:#17120E;display:grid;place-items:center;font-size:.72rem;font-weight:900;margin-top:1px}
.buildx-root .kit-price{display:flex;align-items:baseline;gap:12px;margin-bottom:22px}
.buildx-root .kit-price .big{font-family:'Bricolage Grotesque';font-weight:800;font-size:2.6rem;color:var(--yellow)}
.buildx-root .kit-price small{color:color-mix(in srgb,var(--bg) 65%,transparent)}

.buildx-root .pricing{background:var(--bg-2)}
.buildx-root .tabs{display:flex;justify-content:center;gap:6px;background:var(--surface);border:1px solid var(--line);border-radius:100px;padding:5px;width:max-content;margin:0 auto 16px}
.buildx-root .tab{padding:11px 24px;border-radius:100px;border:none;background:none;font-family:inherit;font-weight:700;font-size:.95rem;cursor:pointer;color:var(--ink-2);transition:.25s}
.buildx-root .tab.active{background:var(--ink);color:var(--bg)}
.buildx-root .bill-note{text-align:center;color:var(--ink-2);font-size:.9rem;margin-bottom:38px}
.buildx-root .bill-toggle{display:none;align-items:center;justify-content:center;gap:14px;margin-bottom:14px;font-weight:700}
.buildx-root .switch{width:54px;height:30px;border-radius:100px;background:var(--ink);position:relative;cursor:pointer;border:none;flex:none}
.buildx-root .switch i{position:absolute;top:3px;left:3px;width:24px;height:24px;border-radius:50%;background:var(--yellow);transition:.28s}
.buildx-root .switch.on i{left:27px}
.buildx-root .save-badge{font-size:.78rem;font-weight:800;color:#fff;background:var(--red);padding:4px 10px;border-radius:100px}
.buildx-root .tier-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:22px;align-items:stretch}
.buildx-root .plan{background:var(--surface);border:1px solid var(--line);border-radius:var(--r);padding:30px 26px;display:flex;flex-direction:column;position:relative;transition:.3s}
.buildx-root .plan:hover{transform:translateY(-6px);box-shadow:var(--shadow)}
.buildx-root .plan.feat{border:2px solid var(--red);box-shadow:var(--shadow)}
.buildx-root .plan-badge{position:absolute;top:-13px;left:50%;transform:translateX(-50%);background:var(--red);color:#fff;font-size:.74rem;font-weight:800;letter-spacing:.05em;padding:6px 16px;border-radius:100px;text-transform:uppercase;white-space:nowrap}
.buildx-root .plan h3{font-size:1.35rem;margin-bottom:6px}
.buildx-root .plan .ptag{color:var(--ink-2);font-size:.9rem;min-height:40px}
.buildx-root .plan .price{font-family:'Bricolage Grotesque';font-weight:800;font-size:2.4rem;margin:14px 0 2px;display:flex;align-items:baseline;gap:6px}
.buildx-root .plan .price small{font-size:.95rem;font-weight:600;color:var(--ink-2);font-family:'Plus Jakarta Sans'}
.buildx-root .plan .price .strike{font-size:1.1rem;color:var(--ink-2);text-decoration:line-through;font-weight:600;font-family:'Plus Jakarta Sans'}
.buildx-root .plan ul{list-style:none;margin:18px 0 24px;display:flex;flex-direction:column;gap:11px}
.buildx-root .plan ul li{display:flex;gap:10px;font-size:.94rem;color:var(--ink-2);align-items:flex-start}
.buildx-root .plan ul li .tk{flex:none;width:19px;height:19px;border-radius:50%;background:color-mix(in srgb,var(--red) 14%,transparent);color:var(--red);display:grid;place-items:center;font-size:.66rem;font-weight:900;margin-top:2px}
.buildx-root .plan .btn{margin-top:auto}
.buildx-root .price-foot{text-align:center;margin-top:34px;color:var(--ink-2);font-size:.92rem}

.buildx-root .addon-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-top:30px}
.buildx-root .addon{background:var(--surface);border:1px dashed var(--line);border-radius:18px;padding:24px;display:flex;flex-direction:column;gap:8px}
.buildx-root .addon h4{font-size:1.15rem}
.buildx-root .addon .cost{font-family:'Bricolage Grotesque';font-weight:800;color:var(--red);font-size:1.3rem}
.buildx-root .addon p{color:var(--ink-2);font-size:.9rem}

.buildx-root .steps{display:grid;grid-template-columns:repeat(4,1fr);gap:24px}
.buildx-root .step{text-align:center;position:relative}
.buildx-root .step .n{width:60px;height:60px;margin:0 auto 18px;border-radius:50%;background:linear-gradient(135deg,var(--red),var(--red-deep));color:#fff;font-family:'Bricolage Grotesque';font-weight:800;font-size:1.5rem;display:grid;place-items:center;box-shadow:0 12px 26px -10px color-mix(in srgb,var(--red) 60%,transparent)}
.buildx-root .step h4{font-size:1.2rem;margin-bottom:8px}
.buildx-root .step p{color:var(--ink-2);font-size:.94rem}

.buildx-root .why-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:22px}
.buildx-root .why{background:var(--surface);border:1px solid var(--line);border-radius:18px;padding:30px;transition:.3s}
.buildx-root .why:hover{border-color:var(--yellow);transform:translateY(-4px);box-shadow:var(--shadow-sm)}
.buildx-root .why .k{font-family:'Bricolage Grotesque';font-weight:800;color:var(--yellow);font-size:1.6rem;background:var(--ink);width:54px;height:54px;border-radius:14px;display:grid;place-items:center;margin-bottom:16px}
html.dark .buildx-root .why .k{background:#070504}
.buildx-root .why h4{font-size:1.3rem;margin-bottom:10px}
.buildx-root .why p{color:var(--ink-2)}

.buildx-root .tst-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}
.buildx-root .tst{background:var(--surface);border:1px solid var(--line);border-radius:18px;padding:28px}
.buildx-root .tst .stars{margin-bottom:14px}
.buildx-root .tst p{font-size:1.02rem;margin-bottom:20px}
.buildx-root .tst .who{display:flex;align-items:center;gap:12px}
.buildx-root .tst .who .pic{width:46px;height:46px;border-radius:50%;background:linear-gradient(135deg,var(--red),var(--yellow));flex:none}
.buildx-root .tst .who b{display:block}
.buildx-root .tst .who small{color:var(--ink-2)}

.buildx-root .lead{background:linear-gradient(135deg,var(--ink),#241a13);color:var(--bg);position:relative;overflow:hidden}
html.dark .buildx-root .lead{background:linear-gradient(135deg,#070504,#1a120d)}
.buildx-root .lead .blob{opacity:.4}
.buildx-root .lead-grid{display:grid;grid-template-columns:1fr 1fr;gap:50px;align-items:center;position:relative;z-index:2}
.buildx-root .lead h2{font-size:clamp(2rem,4vw,3rem);margin-bottom:18px}
.buildx-root .lead h2 .y{color:var(--yellow)}
.buildx-root .lead p.lead-sub{font-size:1.1rem;color:color-mix(in srgb,var(--bg) 78%,transparent);margin-bottom:24px}
.buildx-root .lead-points li{list-style:none;display:flex;gap:11px;margin-bottom:12px;font-weight:600}
.buildx-root .form-card{background:var(--surface);border-radius:var(--r);padding:32px;box-shadow:var(--shadow);color:var(--ink)}
.buildx-root .form-card h3{font-size:1.5rem;margin-bottom:6px}
.buildx-root .form-card .fc-sub{color:var(--ink-2);font-size:.95rem;margin-bottom:22px}
.buildx-root .field{margin-bottom:15px}
.buildx-root .field label{display:block;font-size:.85rem;font-weight:700;margin-bottom:6px}
.buildx-root .field input,.buildx-root .field select,.buildx-root .field textarea{width:100%;padding:13px 15px;border:1.5px solid var(--line);border-radius:12px;background:var(--bg);color:var(--ink);font-family:inherit;font-size:.96rem;transition:.2s}
.buildx-root .field input:focus,.buildx-root .field select:focus,.buildx-root .field textarea:focus{outline:none;border-color:var(--red);box-shadow:0 0 0 4px color-mix(in srgb,var(--red) 12%,transparent)}
.buildx-root .form-status{min-height:1.2em;margin-top:12px;font-size:.88rem;font-weight:600;text-align:center;color:var(--ink-2)}
.buildx-root .form-status.success{color:var(--red)}
.buildx-root .form-status.error{color:#d93025}
.buildx-root .form-ok{display:none;text-align:center;padding:20px 0}
.buildx-root .form-ok .big{font-size:3rem}
.buildx-root .form-ok h3{color:var(--red)}

.buildx-root .faq{max-width:820px;margin:0 auto}
.buildx-root .q-item{border:1px solid var(--line);border-radius:16px;margin-bottom:14px;overflow:hidden;background:var(--surface);transition:.25s}
.buildx-root .q-item.open{border-color:color-mix(in srgb,var(--red) 35%,transparent);box-shadow:var(--shadow-sm)}
.buildx-root .q-head{width:100%;text-align:left;background:none;border:none;cursor:pointer;padding:22px 24px;font-family:'Bricolage Grotesque';font-weight:700;font-size:1.12rem;color:var(--ink);display:flex;justify-content:space-between;align-items:center;gap:16px}
.buildx-root .q-head .pm{flex:none;width:30px;height:30px;border-radius:50%;background:var(--bg-2);display:grid;place-items:center;font-size:1.3rem;font-weight:400;transition:.3s;color:var(--red)}
.buildx-root .q-item.open .pm{background:var(--red);color:#fff;transform:rotate(45deg)}
.buildx-root .q-body{max-height:0;overflow:hidden;transition:max-height .35s ease;color:var(--ink-2)}
.buildx-root .q-body div{padding:0 24px 22px}

.buildx-root .final{text-align:center;background:var(--yellow);color:#17120E;position:relative;overflow:hidden}
.buildx-root .final h2{font-size:clamp(2.2rem,5vw,3.6rem);margin-bottom:18px;color:#17120E}
.buildx-root .final p{font-size:1.18rem;margin-bottom:30px;color:#3a2e22;max-width:600px;margin-left:auto;margin-right:auto}
.buildx-root .final .btn-primary{background:#17120E;box-shadow:0 16px 34px -12px rgba(0,0,0,.4)}
.buildx-root .final .btn-primary:hover{background:#000}
.buildx-root .final small{display:block;margin-top:18px;color:#5a4634;font-weight:600}

.buildx-root footer{background:var(--ink);color:color-mix(in srgb,var(--bg) 72%,transparent);padding:56px 0 30px}
html.dark .buildx-root footer{background:#070504}
.buildx-root .foot-grid{display:grid;grid-template-columns:1.6fr 1fr 1fr 1fr;gap:36px;margin-bottom:38px}
.buildx-root .foot-grid .logo{color:var(--bg);margin-bottom:14px}
.buildx-root footer h5{color:var(--bg);font-family:'Bricolage Grotesque';font-size:1.05rem;margin-bottom:16px}
.buildx-root footer ul{list-style:none}
.buildx-root footer ul li{margin-bottom:10px}
.buildx-root footer ul li a:hover{color:var(--yellow)}
.buildx-root .foot-bot{border-top:1px solid color-mix(in srgb,var(--bg) 16%,transparent);padding-top:24px;display:flex;justify-content:space-between;flex-wrap:wrap;gap:12px;font-size:.88rem}

.buildx-root .sticky-cta{position:fixed;bottom:0;left:0;right:0;z-index:60;background:color-mix(in srgb,var(--bg) 92%,transparent);backdrop-filter:blur(14px);border-top:1px solid var(--line);padding:12px 16px;display:none;gap:10px;align-items:center}
.buildx-root .sticky-cta .btn{flex:1}

.buildx-root .reveal{opacity:0;transform:translateY(34px);transition:opacity .7s cubic-bezier(.2,.8,.2,1),transform .7s cubic-bezier(.2,.8,.2,1)}
.buildx-root .reveal.in-view{opacity:1;transform:none}
.buildx-root .reveal.d1{transition-delay:.08s}.buildx-root .reveal.d2{transition-delay:.16s}.buildx-root .reveal.d3{transition-delay:.24s}.buildx-root .reveal.d4{transition-delay:.32s}

/* Dark-mode readability overrides for sections that use --bg as text color */
html.dark .buildx-root .stats,
html.dark .buildx-root .kit,
html.dark .buildx-root .lead,
html.dark .buildx-root footer{color:#F8F1E7}
html.dark .buildx-root .kit p.lead,
html.dark .buildx-root .lead p.lead-sub{color:color-mix(in srgb,#F8F1E7 78%,transparent)}
html.dark .buildx-root .stat .lbl{color:color-mix(in srgb,#F8F1E7 75%,transparent)}
html.dark .buildx-root .kit-price small{color:color-mix(in srgb,#F8F1E7 65%,transparent)}
html.dark .buildx-root footer{color:color-mix(in srgb,#F8F1E7 72%,transparent)}
html.dark .buildx-root footer h5,
html.dark .buildx-root .foot-grid .logo{color:#F8F1E7}
html.dark .buildx-root .foot-bot{border-top-color:color-mix(in srgb,#F8F1E7 16%,transparent)}

@media(max-width:920px){
  .buildx-root .hero-grid,.buildx-root .kit-grid,.buildx-root .lead-grid{grid-template-columns:1fr;gap:40px}
  .buildx-root .stats-grid,.buildx-root .steps{grid-template-columns:repeat(2,1fr);gap:30px}
  .buildx-root .svc-grid,.buildx-root .pain-grid,.buildx-root .why-grid,.buildx-root .kit-list{grid-template-columns:1fr}
  .buildx-root .tier-grid,.buildx-root .tst-grid,.buildx-root .addon-grid{grid-template-columns:1fr}
  .buildx-root .nav-links{display:none}
  .buildx-root .menu-btn{display:block}
  .buildx-root .foot-grid{grid-template-columns:1fr 1fr}
  .buildx-root .hero-visual{order:-1}
  .buildx-root .float-chip{display:none}
  .buildx-root .sticky-cta{display:flex}
  .buildx-root .mobile-menu.open{display:block;position:fixed;inset:0;top:0;z-index:80;background:var(--bg);padding:90px 28px 40px}
  .buildx-root .mobile-menu.open a{display:block;font-family:'Bricolage Grotesque';font-weight:700;font-size:1.6rem;padding:14px 0;border-bottom:1px solid var(--line)}
  .buildx-root .mobile-menu .close{position:absolute;top:24px;right:24px;background:none;border:none;font-size:2rem;color:var(--ink);cursor:pointer}
  .buildx-root .mobile-menu .btn{margin-top:24px;width:100%}
}
@media(max-width:560px){.buildx-root .stats-grid,.buildx-root .steps{grid-template-columns:1fr}.buildx-root .hero-cta .btn{width:100%}.buildx-root .foot-grid{grid-template-columns:1fr}}
`;

const BODY_HTML = `
<div class="announce">
  <div class="wrap">
    <span class="live"><span class="dot"></span>LIVE</span>
    <span>24+ businesses launched in the last 10 days — only a few build slots left this month.</span>
    <a href="#lead">Claim a build slot →</a>
  </div>
</div>

<header id="header">
  <div class="wrap nav">
    <a href="#" class="logo">Build<span class="x">X</span></a>
    <nav class="nav-links">
      <a href="#services">Services</a>
      <a href="#kit">Launch Kit</a>
      <a href="#pricing">Pricing</a>
      <a href="#results">Results</a>
      <a href="#faq">FAQ</a>
    </nav>
    <div class="nav-right">
      <button class="toggle" id="themeBtn" aria-label="Toggle theme">
        <svg id="sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
      </button>
      <a href="#lead" class="btn btn-primary" style="padding:12px 22px">Book a Free Call</a>
      <button class="menu-btn" id="menuBtn" aria-label="Menu"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M3 6h18M3 12h18M3 18h18"/></svg></button>
    </div>
  </div>
</header>

<div class="mobile-menu" id="mobileMenu">
  <button class="close" id="closeMenu">×</button>
  <a href="#services">Services</a>
  <a href="#kit">Launch Kit</a>
  <a href="#pricing">Pricing</a>
  <a href="#results">Results</a>
  <a href="#faq">FAQ</a>
  <a href="#lead" class="btn btn-primary">Book a Free Call</a>
</div>

<section class="hero">
  <div class="blob b1"></div>
  <div class="blob b2"></div>
  <div class="wrap hero-grid">
    <div class="hero-copy">
      <span class="eyebrow reveal"><span class="dot"></span>AI-Powered Growth Studio</span>
      <h1 class="reveal d1">Your competitors look bigger than you online. <span class="hl"><br>Even when they are <span class="mark">NOT.</span></span></h1>
      <p class="sub reveal d2">Launch a professional website, content system and marketing assets in just 3 days.Built to attract customers, generate enquiries and help your business grow — without hiring an agency or learning AI.
      <div class="hero-cta reveal d3">
        <a href="#lead" class="btn btn-primary btn-lg">Launch My Business with AI <span class="arrow">→</span></a>
        <a href="#pricing" class="btn btn-ghost btn-lg">See AI Website Plan</a>
      </div>
      <div class="hero-trust reveal d4">
        <div class="avatars">
          <img src="/founders/founder1.png" alt="Founder 1">
          <img src="/founders/founder2.png" alt="Founder 2">
          <img src="/founders/founder3.png" alt="Founder 3">
          <img src="/founders/founder4.png" alt="Founder 4">
        </div>
        <div>
          <span class="stars">★★★★★</span><br>
          Trusted by founders who don't have time to learn AI
        </div>
</div>
    </div>
    <div class="hero-visual reveal d2">
      <div class="ai-visual">
        <img src="https://customer-assets.emergentagent.com/job_same-copy/artifacts/4kfljuta_cartoon-woman-wearing-glasses.jpg" alt="Creative founder using AI on a laptop" />
      </div>
      <div class="float-chip fc-1"><span class="ic" style="background:color-mix(in srgb,var(--yellow) 30%,transparent)">⚡</span><div><b>3-day launch</b><small>idea → live</small></div></div>
      <div class="float-chip fc-2"><span class="ic" style="background:color-mix(in srgb,var(--red) 18%,transparent)">↗</span><div><b>+ leads</b><small>built to convert</small></div></div>
      <div class="float-chip fc-3"><span class="ic" style="background:color-mix(in srgb,var(--yellow) 30%,transparent)">₹</span><div><b>Agency quality</b><small>fraction of cost</small></div></div>
    </div>
  </div>
</section>

<div class="ticker">
  <div class="ticker-track">
    <span>AI Websites&nbsp;&nbsp; Social Media Creatives&nbsp;&nbsp; Content Calendars&nbsp;&nbsp; Meta Ad Videos&nbsp;&nbsp; GMB Profiles&nbsp;&nbsp; Launch Kits&nbsp;&nbsp; Monthly Retainers&nbsp;&nbsp;</span>
    <span>AI Websites&nbsp;&nbsp; Social Media Creatives&nbsp;&nbsp; Content Calendars&nbsp;&nbsp; Meta Ad Videos&nbsp;&nbsp; GMB Profiles&nbsp;&nbsp; Launch Kits&nbsp;&nbsp; Monthly Retainers&nbsp;&nbsp;</span>
  </div>
</div>

<section class="stats">
  <div class="wrap stats-grid">
    <div class="stat reveal"><div class="num" data-target="24" data-suffix="+">0</div><div class="lbl">Businesses launched<br>in the last 10 days</div></div>
    <div class="stat reveal d1"><div class="num" data-target="200" data-suffix="+">0</div><div class="lbl">Scroll-stopping<br>creatives designed</div></div>
    <div class="stat reveal d2"><div class="num" data-target="10" data-suffix="+">0</div><div class="lbl">Meta ad campaign<br>videos produced</div></div>
    <div class="stat reveal d3"><div class="num" data-target="93" data-suffix="%">0</div><div class="lbl">Saved vs. typical<br>agency timelines</div></div>
  </div>
</section>

<section class="sec problem" style="display:none">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow"><span class="dot"></span>Let's be honest</span>
      <h2>Be honest — is AI actually working <em>for</em> your business?</h2>
      <p>Everyone says AI is a game-changer. But for most small businesses, it's still just a chatbot they tried once and forgot.</p>
    </div>
    <div class="pain-grid">
      <div class="pain reveal"><div class="q">01</div><p>You've <strong>heard</strong> AI can transform your business — but you've only played with a chatbot and moved on. The wow faded by the weekend.</p></div>
      <div class="pain reveal d1"><div class="q">02</div><p>You're paying <strong>agency prices</strong> for work AI now does faster, sharper, and for a fraction of the cost.</p></div>
      <div class="pain reveal d2"><div class="q">03</div><p>Your website, your posts, your ads — they look like <strong>everyone else's</strong>. Nothing makes a customer stop and choose <em>you</em>.</p></div>
      <div class="pain reveal d3"><div class="q">04</div><p>You don't have a tech team — and every "solution" out there <strong>assumes you do</strong>.</p></div>
    </div>
    <div class="center reveal d2" style="margin-top:40px">
      <a href="#shift" class="btn btn-primary btn-lg">Show me a better way <span class="arrow">→</span></a>
    </div>
  </div>
</section>

<section class="sec shift" id="shift">
  <div class="wrap reveal">
    <span class="eyebrow" style="background:rgba(255,255,255,.15);border-color:rgba(255,255,255,.3);color:#fff"><span class="dot" style="background:var(--yellow)"></span>The real AI advantage</span>
    <h2 style="margin-top:20px">Use AI to grow your <span class="y">money</span> — not just to feel the wow and forget it.</h2>
    <p>The wow factor lasts a weekend. A real AI advantage shows up in your bank account: lower costs, faster launches, more leads, and work that looks like you spent ten times what you did. That's the only kind of AI we build at BuildX.</p>
    <a href="#services" class="btn btn-yellow btn-lg">Show me what you build <span class="arrow">→</span></a>
  </div>
</section>

<section class="sec" id="services">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow"><span class="dot"></span>What we build</span>
      <h2>Everything your business needs to look big — and convert</h2>
      <p>Order each piece on its own, or bundle them into a single launch-ready kit. All AI-powered. All built to win customers.</p>
    </div>
    <div class="svc-grid">
      <div class="svc reveal">
        <div class="ai-visual"><img src="https://customer-assets.emergentagent.com/job_same-copy/artifacts/wfydhntc_ChatGPT%20Image%20Jun%208%2C%202026%2C%2001_10_01%20PM.png" alt="AI-powered website displayed on laptop and phone with glowing accents" /></div>
        <div class="svc-body">
          <h3>AI-Powered Websites</h3>
          <span class="price-chip">Starting from <b>₹10,999</b></span>
          <p>Fast, beautiful, conversion-built websites launched in days, not months — designed to turn visitors into buyers.</p>
          <div class="tier-row"><span class="tier">Standard</span><span class="tier">Premium</span><span class="tier">Advanced</span></div>
          <a href="#pricing" class="svc-link">See website plans <span class="arrow">→</span></a>
        </div>
      </div>
      <div class="svc reveal d1">
        <div class="ai-visual"><img src="https://customer-assets.emergentagent.com/job_same-copy/artifacts/1z1nnewv_ChatGPT%20Image%20Jun%208%2C%202026%2C%2001_10_09%20PM.png" alt="Social media content calendar with platform icons and post types" /></div>
        <div class="svc-body">
          <h3>Social Media Content Calendar</h3>
          <span class="price-chip">Starting from <b>₹5,999/mo</b></span>
          <p>A done-for-you monthly plan — every post, caption and hook mapped out so you're never staring at a blank screen again.</p>
          <div class="tier-row"><span class="tier">Monthly</span><span class="tier">Quarterly</span></div>
          <a href="#pricing" class="svc-link">See calendar plans <span class="arrow">→</span></a>
        </div>
      </div>
      <div class="svc reveal d2">
        <div class="ai-visual"><img src="https://customer-assets.emergentagent.com/job_same-copy/artifacts/wz6hn28r_ChatGPT%20Image%20Jun%208%2C%202026%2C%2001_10_17%20PM.png" alt="Vibrant social media creatives with product posts and engagement icons" /></div>
        <div class="svc-body">
          <h3>Social Media Creatives</h3>
          <span class="price-chip">Starting from <b>₹7,999</b></span>
          <p>Scroll-stopping, on-brand posts and ad creatives that make people pause, trust you, and tap — designed to perform, not just decorate.</p>
          <div class="tier-row"><span class="tier">Starter pack</span><span class="tier">Pro pack</span></div>
          <a href="#pricing" class="svc-link">See creative packs <span class="arrow">→</span></a>
        </div>
      </div>
      <div class="svc reveal d3">
        <div class="ai-visual">
          <img src="https://customer-assets.emergentagent.com/job_same-copy/artifacts/2ow38634_ChatGPT%20Image%20Jun%208%2C%202026%2C%2001_10_28%20PM.png" alt="Phone on tripod shooting a high-performing ad video with engagement metrics" />
        </div>
        <div class="svc-body">
          <h3>Social Media &amp; Meta Ad Videos</h3>
          <span class="price-chip">Starting from <b>₹10,999</b></span>
          <p>Thumb-stopping short videos and Meta ad creatives engineered for reach and conversions — the format the algorithm rewards most.</p>
          <div class="tier-row"><span class="tier">Reel pack</span><span class="tier">Ad video pack</span></div>
          <a href="#pricing" class="svc-link">See video plans <span class="arrow">→</span></a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="sec pricing" id="pricing">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow"><span class="dot"></span>Pricing</span>
      <h2>Pick what you need. Pay what's fair.</h2>
      <p>Choose a one-time build, or grow with us monthly. Lock an annual plan and save 30%.</p>
    </div>

    <div class="reveal">
      <div class="tabs">
        <button class="tab active" data-tab="build">Build Once</button>
        <button class="tab" data-tab="grow">Grow Monthly</button>
      </div>
      <p class="bill-note">Indicative pricing — your exact quote comes free after a 15-minute strategy call.</p>

      <div class="bill-toggle" id="billToggle">
        <span>Monthly</span>
        <button class="switch" id="annualSwitch"><i></i></button>
        <span>Annual <span class="save-badge">SAVE 30%</span></span>
      </div>
    </div>

    <div id="pane-build">
      <div class="tier-grid">
        <div class="plan reveal">
          <h3>Standard Website</h3>
          <p class="ptag">Get online fast with a clean, credible presence.</p>
          <div class="price">₹10,999</div>
          <ul>
            <li><span class="tk">✓</span> Up to 5 pages, mobile-ready</li>
            <li><span class="tk">✓</span> AI-written copy &amp; layout</li>
            <li><span class="tk">✓</span> Contact &amp; enquiry form</li>
            <li><span class="tk">✓</span> Basic SEO setup</li>
            <li><span class="tk">✓</span> Live in ~3 days</li>
          </ul>
          <a href="#lead" class="btn btn-ghost btn-block">Choose Standard</a>
        </div>
        <div class="plan feat reveal d1">
          <span class="plan-badge">Most Popular</span>
          <h3>Premium Website</h3>
          <p class="ptag">A polished site built to convert visitors into leads.</p>
          <div class="price">₹19,999</div>
          <ul>
            <li><span class="tk">✓</span> Up to 10 pages + custom design</li>
            <li><span class="tk">✓</span> Conversion-optimised layout</li>
            <li><span class="tk">✓</span> Lead capture + WhatsApp click</li>
            <li><span class="tk">✓</span> AI visuals &amp; on-brand creatives</li>
            <li><span class="tk">✓</span> Advanced SEO + analytics</li>
          </ul>
          <a href="#lead" class="btn btn-primary btn-block">Choose Premium</a>
        </div>
        <div class="plan reveal d2">
          <h3>Advanced Website</h3>
          <p class="ptag">A serious growth engine with smart, AI-driven features.</p>
          <div class="price">₹39,999</div>
          <ul>
            <li><span class="tk">✓</span> Unlimited pages + bookings/store</li>
            <li><span class="tk">✓</span> AI chat assistant integration</li>
            <li><span class="tk">✓</span> Funnels &amp; landing pages</li>
            <li><span class="tk">✓</span> Automations &amp; integrations</li>
            <li><span class="tk">✓</span> Priority build &amp; support</li>
          </ul>
          <a href="#lead" class="btn btn-ghost btn-block">Choose Advanced</a>
        </div>
      </div>

      <div class="tier-grid" style="margin-top:22px">
        <div class="plan reveal">
          <h3>Content Calendar</h3>
          <p class="ptag">A full month of posts, mapped &amp; ready.</p>
          <div class="price">₹5,999 <small>/mo</small></div>
          <ul>
            <li><span class="tk">✓</span> 30-day post plan</li>
            <li><span class="tk">✓</span> Hooks, captions &amp; hashtags</li>
            <li><span class="tk">✓</span> Platform-ready scheduling</li>
          </ul>
          <a href="#lead" class="btn btn-ghost btn-block">Add Calendar</a>
        </div>
        <div class="plan reveal d1">
          <h3>Creatives Pack</h3>
          <p class="ptag">On-brand designs that stop the scroll.</p>
          <div class="price">₹7,999</div>
          <ul>
            <li><span class="tk">✓</span> 15 scroll-stopping creatives</li>
            <li><span class="tk">✓</span> Stories + feed formats</li>
            <li><span class="tk">✓</span> Ad-ready variations</li>
          </ul>
          <a href="#lead" class="btn btn-ghost btn-block">Add Creatives</a>
        </div>
        <div class="plan reveal d2">
          <h3>Video Pack</h3>
          <p class="ptag">Reels &amp; Meta ad videos that perform.</p>
          <div class="price">₹10,999</div>
          <ul>
            <li><span class="tk">✓</span> 5 short-form videos</li>
            <li><span class="tk">✓</span> Hooks built for retention</li>
            <li><span class="tk">✓</span> Meta-ad optimised cuts</li>
          </ul>
          <a href="#lead" class="btn btn-ghost btn-block">Add Videos</a>
        </div>
      </div>

      <div class="center" style="margin-top:30px">
      </div>
    </div>

    <div id="pane-grow" style="display:none">
      <div class="tier-grid">
        <div class="plan reveal">
          <h3>Social Media Retainer</h3>
          <p class="ptag">We run your content engine, month after month.</p>
          <div class="price"><span data-monthly="19999" data-annual="13999">₹19,999</span> <small>/mo</small></div>
          <ul>
            <li><span class="tk">✓</span> Full monthly content calendar</li>
            <li><span class="tk">✓</span> Creatives + short videos</li>
            <li><span class="tk">✓</span> Scheduling &amp; light reporting</li>
            <li><span class="tk">✓</span> <strong id="annualLine" style="color:var(--red)">Annual: 30% off, auto-debited monthly</strong></li>
          </ul>
          <a href="#lead" class="btn btn-primary btn-block">Start My Monthly Plan</a>
        </div>
        <div class="plan feat reveal d1">
          <span class="plan-badge">Most Popular</span>
          <h3>Growth Retainer</h3>
          <p class="ptag">Everything in Social, plus paid ads management.</p>
          <div class="price"><span data-monthly="34999" data-annual="24499">₹34,999</span> <small>/mo</small></div>
          <ul>
            <li><span class="tk">✓</span> Everything in Social Media</li>
            <li><span class="tk">✓</span> Meta ad campaigns + ad videos</li>
            <li><span class="tk">✓</span> Landing pages for campaigns</li>
            <li><span class="tk">✓</span> Performance reporting</li>
          </ul>
          <a href="#lead" class="btn btn-primary btn-block">Start Growth Plan</a>
        </div>
        <div class="plan reveal d2">
          <h3>Dedicated SM Executive</h3>
          <p class="ptag">Your own social media person, on monthly retainer.</p>
          <div class="price"><span data-monthly="15000" data-annual="10500">₹15,000</span> <small>/mo</small></div>
          <ul>
            <li><span class="tk">✓</span> Dedicated point of contact</li>
            <li><span class="tk">✓</span> Daily posting &amp; engagement</li>
            <li><span class="tk">✓</span> Community management</li>
            <li><span class="tk">✓</span> Add to any retainer</li>
          </ul>
          <a href="#lead" class="btn btn-ghost btn-block">Add an Executive</a>
        </div>
      </div>
      <p class="price-foot reveal">Annual plans bill at a 30% discount and are conveniently auto-debited every month — cancel anytime per your agreement.</p>
    </div>

    <div class="reveal" style="margin-top:60px">
      <h3 class="center" style="font-size:1.6rem;margin-bottom:8px">Add-ons, anytime</h3>
      <p class="center" style="color:var(--ink-2)">Boost any plan or kit with on-demand extras.</p>
      <div class="addon-grid">
        <div class="addon"><h4>Professional Photoshoot</h4><div class="cost">On request</div><p>On-location product or brand photography, requested for an additional cost.</p></div>
        <div class="addon"><h4>Video Shoot</h4><div class="cost">On request</div><p>Professional video capture for ads and reels, requested for an additional cost.</p></div>
        <div class="addon"><h4>Dedicated SM Executive</h4><div class="cost">₹15,000/mo</div><p>A dedicated social media executive added to your plan on a monthly basis.</p></div>
      </div>
    </div>
  </div>
</section>

<section class="sec kit" id="kit">
  <div class="blob b2" style="opacity:.25"></div>
  <div class="wrap kit-grid">
    <div class="reveal">
      <span class="eyebrow"><span class="dot"></span>The all-in-one solution</span>
      <h2>The <span class="y">Launch Kit</span> — your whole business, ready to go live.</h2>
      <p class="lead">Don't piece it together. Get everything you need to launch and start winning customers — one kit, one price, one fast turnaround.</p>
      <ul class="kit-list">
        <li><span class="tick">✓</span> AI-powered website</li>
        <li><span class="tick">✓</span> Google Business (GMB) profile planner</li>
        <li><span class="tick">✓</span> Social media strategy</li>
        <li><span class="tick">✓</span> 30-day content calendar</li>
        <li><span class="tick">✓</span> Launch creatives pack</li>
        <li><span class="tick">✓</span> Launch ad videos</li>
      </ul>
      <div class="kit-price">
        <span class="big">₹49,999<small>*</small></span>
        <small>everything above, launch-ready &nbsp;·&nbsp; *indicative</small>
      </div>
      <a href="#lead" class="btn btn-yellow btn-lg">Get the Launch Kit <span class="arrow">→</span></a>
    </div>
    <div class="reveal d2 hero-visual">
      <div class="ai-visual" style="min-height:520px"><img src="https://customer-assets.emergentagent.com/job_same-copy/artifacts/5ps3qynn_ChatGPT%20Image%20Jun%208%2C%202026%2C%2001_10_37%20PM.png" alt="The Launch Kit — rocket launching with website, calendar, creatives and ad videos" /></div>
    </div>
  </div>
</section>

<section class="sec" style="background:var(--bg-2)">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow"><span class="dot"></span>How it works</span>
      <h2>From idea to live in days — without the headache</h2>
    </div>
    <div class="steps">
      <div class="step reveal"><div class="n">1</div><h4>Free Strategy Call</h4><p>Tell us about your business in 15 minutes. We map out exactly what you need.</p></div>
      <div class="step reveal d1"><div class="n">2</div><h4>We Build with AI</h4><p>Our AI-powered studio creates your website, content and creatives — fast.</p></div>
      <div class="step reveal d2"><div class="n">3</div><h4>You Review</h4><p>See it, tweak it, approve it. No jargon, no endless back-and-forth.</p></div>
      <div class="step reveal d3"><div class="n">4</div><h4>Go Live &amp; Grow</h4><p>Launch and start winning customers — with us behind you every month if you want.</p></div>
    </div>
  </div>
</section>

<section class="sec">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow"><span class="dot"></span>Why BuildX</span>
      <h2>The AI advantage, built for businesses like yours</h2>
      <p>Latest tech. Honest prices. Work that actually performs. Made for founders who'd rather run the business than learn the tools.</p>
    </div>
    <div class="why-grid">
      <div class="why reveal"><div class="k">↻</div><h4>Latest, not last-year</h4><p>We build on the newest AI the moment it ships — so you're never a version behind the competition.</p></div>
      <div class="why reveal d1"><div class="k">₹</div><h4>Cost-effective by design</h4><p>Agency-quality output at a fraction of agency cost. AI does the heavy lifting; you keep the savings.</p></div>
      <div class="why reveal d2"><div class="k">★</div><h4>Superior, not "good enough"</h4><p>Templates make you blend in. We make work that makes customers stop, trust, and buy.</p></div>
      <div class="why reveal d3"><div class="k">♥</div><h4>Built for non-techies</h4><p>You run the business. We run the tech. Zero jargon, zero headaches, zero AI homework.</p></div>
    </div>
  </div>
</section>

<section class="sec" id="results" style="background:var(--bg-2)">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow"><span class="dot"></span>Results</span>
      <h2>Founders who stopped doing it the hard way</h2>
      <p>Real wins from Kerala small businesses using BuildX to launch fast and grow.</p>
    </div>
    <div class="tst-grid">
      <div class="tst reveal"><div class="stars">★★★★★</div><p>"We run an Ayurveda clinic in Kochi and were drowning in WhatsApp enquiries. BuildX launched our website and reels in 4 days — bookings jumped almost 3x in the first month."</p>
      <div class="who">
          <img class="pic" src="/testimonials/arjun.png" alt="Arjun Nair">
          <div>
            <b>Arjun Nair</b>
            <small>Founder · Wellness D2C · Kochi</small>
          </div>
        </div>
      </div>
      
      
      <div class="tst reveal d1"><div class="stars">★★★★★</div><p>"I run a small homestay in Wayanad. I had no marketing person, no time, no clue about AI. BuildX handled everything — site, posts, reels — and now we're booked out every weekend."</p>
      <div class="who">
          <img class="pic" src="/testimonials/meera.png" alt="Meera Pillai">
          <div>
            <b>Meera Pillai</b>
            <small>Owner · Hospitality & Travel · Wayanad</small>
          </div>
        </div>
      </div>
      <div class="tst reveal d2"><div class="stars">★★★★★</div><p>"Our Trivandrum bakery used to spend ₹40k/month on a freelance designer + ads guy. With BuildX's Launch Kit we got better creatives and ad videos for a fraction of that. ROI was insane."</p>
      <div class="who">
          <img class="pic" src="/testimonials/joseph.png" alt="Joseph Mathew">
          <div>
            <b>Joseph Mathew</b>
            <small>Co-founder · F&amp;B / D2C · Thiruvananthapuram</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="sec lead" id="lead">
  <div class="blob b1"></div>
  <div class="wrap lead-grid">
    <div class="reveal">
      <span class="eyebrow" style="background:rgba(255,255,255,.14);border-color:rgba(255,255,255,.3);color:#fff"><span class="dot" style="background:var(--yellow)"></span>Get Instant Proposal Now</span>
      <h2 style="margin-top:18px">Get a tailored <span class="y">AI growth plan</span> for your business.</h2>
      <p class="lead-sub">Tell us a little about your business. In 15 minutes we'll show you exactly where AI can save you money and win you customers — and quote your real price.</p>
      <ul class="lead-points">
        <li><span class="tick">✓</span> A clear, honest quote — no surprises</li>
        <li><span class="tick">✓</span> Your fastest path to launch</li>
        <li><span class="tick">✓</span> Zero obligation, zero jargon</li>
      </ul>
    </div>
    <div class="reveal d1">
      <div class="form-card">
        <div id="formMain">
          <h3>Claim your free plan</h3>
          <p class="fc-sub">Limited build slots this month — get yours.</p>
          <div class="field"><label>Your name</label><input type="text" id="f-name" placeholder="e.g. Aarav Menon"></div>
          <div class="field"><label>WhatsApp / Phone</label><input type="tel" id="f-phone" placeholder="+91 ..."></div>
          <div class="field"><label>Enquiry type</label>
            <select id="f-enquiry">
              <option>The Launch Kit (everything)</option>
              <option>AI website</option>
              <option>Social media content &amp; creatives</option>
              <option>Ad videos / Meta campaigns</option>
              <option>A monthly retainer</option>
              <option>Not sure yet — advise me</option>
            </select>
          </div>
          <button class="btn btn-primary btn-lg btn-block" id="submitBtn">Submit Your Request <span class="arrow">→</span></button>
          <div class="form-status" id="formStatus" aria-live="polite"></div>
          <p style="text-align:center;font-size:.78rem;color:var(--ink-2);margin-top:12px">We'll only use your details to contact you about your plan.</p>
        </div>
        <div class="form-ok" id="formOk">
          <div class="big">✓</div>
          <h3>You're in!</h3>
          <p style="color:var(--ink-2);margin-top:8px">We'll reach out shortly with your free AI growth plan. Your details have also been sent to the admin inbox.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="sec" id="faq">
  <div class="wrap">
    <div class="sec-head reveal">
      <span class="eyebrow"><span class="dot"></span>FAQ</span>
      <h2>Questions, answered</h2>
    </div>
    <div class="faq">
      <div class="q-item reveal"><button class="q-head">Do I need to know anything about AI or tech?<span class="pm">+</span></button><div class="q-body"><div>Not at all. That's the whole point of BuildX. You tell us about your business in plain language, and we handle every technical part for you.</div></div></div>
      <div class="q-item reveal d1"><button class="q-head">How fast can my website go live?<span class="pm">+</span></button><div class="q-body"><div>Standard sites can go live in around 3 days. Premium and Advanced builds take a little longer depending on features, and we'll give you a clear timeline on your free call.</div></div></div>
      <div class="q-item reveal d2"><button class="q-head">How does the annual retainer discount work?<span class="pm">+</span></button><div class="q-body"><div>Choose an annual plan and you save 30% versus monthly. For convenience, the discounted amount is auto-debited every month rather than charged as one lump sum.</div></div></div>
      <div class="q-item reveal d3"><button class="q-head">Can I add a photoshoot, video shoot, or a dedicated executive?<span class="pm">+</span></button><div class="q-body"><div>Yes. Photoshoots and video shoots can be requested as add-ons for an additional cost, and a dedicated social media executive can be added to any plan on a monthly basis.</div></div></div>
      <div class="q-item reveal d4"><button class="q-head">Is the pricing on this page final?<span class="pm">+</span></button><div class="q-body"><div>It's indicative, to give you a clear idea. Your exact quote is tailored to your business and shared free after a quick strategy call.</div></div></div>
    </div>
  </div>
</section>

<section class="sec final">
  <div class="wrap reveal">
    <h2>Your competitors won't wait.<br/>Neither should you.</h2>
    <p>Stop watching AI from the sidelines. Let's put it to work for your business — and your bank account.</p>
    <a href="#lead" class="btn btn-primary btn-lg">Yes, Build My Business <span class="arrow">→</span></a>
    <small>Free strategy call · No obligation · A few build slots left this month</small>
  </div>
</section>

<footer>
  <div class="wrap">
    <div class="foot-grid">
      <div>
        <a href="#" class="logo">Build<span class="x">X</span></a>
        <p style="max-width:300px">AI-powered websites, content, creatives and videos that bring the AI advantage to small businesses, startups and entrepreneurs.</p>
      </div>
      <div><h5>Services</h5><ul><li><a href="#services">Websites</a></li><li><a href="#services">Content Calendar</a></li><li><a href="#services">Creatives</a></li><li><a href="#services">Ad Videos</a></li></ul></div>
      <div><h5>Solutions</h5><ul><li><a href="#kit">Launch Kit</a></li><li><a href="#pricing">Monthly Retainers</a></li><li><a href="#pricing">Add-ons</a></li><li><a href="#lead">Free Strategy Call</a></li></ul></div>
      <div><h5>Company</h5><ul><li><a href="#results">Results</a></li><li><a href="#faq">FAQ</a></li><li><a href="#lead">Contact</a></li></ul></div>
    </div>
    <div class="foot-bot">
      <span>© 2026 BuildX. All rights reserved.</span>
      <span>Bringing the AI advantage to the businesses that need it most.</span>
    </div>
  </div>
</footer>

<div class="sticky-cta">
  <a href="#lead" class="btn btn-primary">Free Strategy Call</a>
</div>
<a
  href="https://wa.me/917306877795?text=Hi%20BuildX%2C%20I%27m%20interested%20in%20your%20services."
  target="_blank"
  rel="noopener noreferrer"
  class="whatsapp-float"
>
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
    alt="WhatsApp"
  />
</a>
`;

export default function BuildX() {
  const rootRef = useRef(null);

  useEffect(() => {
    // Inject Google Fonts once
    if (!document.getElementById("buildx-fonts")) {
      const preconnect1 = document.createElement("link");
      preconnect1.rel = "preconnect";
      preconnect1.href = "https://fonts.googleapis.com";
      document.head.appendChild(preconnect1);
      const preconnect2 = document.createElement("link");
      preconnect2.rel = "preconnect";
      preconnect2.href = "https://fonts.gstatic.com";
      preconnect2.crossOrigin = "";
      document.head.appendChild(preconnect2);
      const link = document.createElement("link");
      link.id = "buildx-fonts";
      link.rel = "stylesheet";
      link.href =
        "https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,500;12..96,700;12..96,800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap";
      document.head.appendChild(link);
    }

    // Set page title
    document.title = "BuildX — AI-Powered Growth Studio for Small Businesses & Startups";

    const root = rootRef.current;
    if (!root) return;

    // theme toggle
    const htmlEl = document.documentElement;
    const tBtn = root.querySelector("#themeBtn");
    const sun = root.querySelector("#sun");
    const onTheme = () => {
      htmlEl.classList.toggle("dark");
      if (sun) {
        sun.innerHTML = htmlEl.classList.contains("dark")
          ? '<path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z"/>'
          : '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>';
      }
    };
    tBtn && tBtn.addEventListener("click", onTheme);

    // header scrolled state
    const header = root.querySelector("#header");
    const onScroll = () => {
      if (header) header.classList.toggle("scrolled", window.scrollY > 20);
    };
    window.addEventListener("scroll", onScroll);

    // mobile menu
    const mm = root.querySelector("#mobileMenu");
    const menuBtn = root.querySelector("#menuBtn");
    const closeMenu = root.querySelector("#closeMenu");
    const openMM = () => mm && mm.classList.add("open");
    const closeMM = () => mm && mm.classList.remove("open");
    menuBtn && menuBtn.addEventListener("click", openMM);
    closeMenu && closeMenu.addEventListener("click", closeMM);
    const mmLinks = mm ? mm.querySelectorAll("a") : [];
    mmLinks.forEach((a) => a.addEventListener("click", closeMM));

    // reveal on scroll
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.12 }
    );
    root.querySelectorAll(".reveal").forEach((el) => io.observe(el));

    // count up
    const cup = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const el = e.target;
          const t = +el.dataset.target;
          const suf = el.dataset.suffix || "";
          let n = 0;
          const step = t / 60;
          const run = () => {
            n += step;
            if (n >= t) {
              el.textContent = t + suf;
            } else {
              el.textContent = Math.floor(n) + suf;
              requestAnimationFrame(run);
            }
          };
          run();
          cup.unobserve(el);
        }),
      { threshold: 0.5 }
    );
    root.querySelectorAll(".num").forEach((el) => cup.observe(el));

    // pricing tabs
    const tabs = root.querySelectorAll(".tab");
    const paneB = root.querySelector("#pane-build");
    const paneG = root.querySelector("#pane-grow");
    const bt = root.querySelector("#billToggle");
    const tabHandlers = [];
    tabs.forEach((tab) => {
      const handler = () => {
        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");
        const grow = tab.dataset.tab === "grow";
        if (paneB) paneB.style.display = grow ? "none" : "block";
        if (paneG) paneG.style.display = grow ? "block" : "none";
        if (bt) bt.style.display = grow ? "flex" : "none";
      };
      tab.addEventListener("click", handler);
      tabHandlers.push([tab, handler]);
    });

    // annual switch
    const aSwitch = root.querySelector("#annualSwitch");
    const aLine = root.querySelector("#annualLine");
    const onSwitch = () => {
      const on = aSwitch.classList.toggle("on");
      root.querySelectorAll("[data-monthly]").forEach((s) => {
        const v = on ? s.dataset.annual : s.dataset.monthly;
        s.textContent = "₹" + Number(v).toLocaleString("en-IN");
      });
      if (aLine)
        aLine.textContent = on
          ? "Annual: billed at 30% off, auto-debited monthly"
          : "Annual: 30% off, auto-debited monthly";
    };
    aSwitch && aSwitch.addEventListener("click", onSwitch);

    // faq
    const qHeads = root.querySelectorAll(".q-head");
    const qHandlers = [];
    qHeads.forEach((h) => {
      const handler = () => {
        const item = h.parentElement;
        const body = h.nextElementSibling;
        const open = item.classList.contains("open");
        root.querySelectorAll(".q-item").forEach((i) => {
          i.classList.remove("open");
          const b = i.querySelector(".q-body");
          if (b) b.style.maxHeight = null;
        });
        if (!open) {
          item.classList.add("open");
          if (body) body.style.maxHeight = body.scrollHeight + "px";
        }
      };
      h.addEventListener("click", handler);
      qHandlers.push([h, handler]);
    });

    // form
    const submitBtn = root.querySelector("#submitBtn");
    const formStatus = root.querySelector("#formStatus");
    const setFormStatus = (message = "", kind = "") => {
      if (!formStatus) return;
      formStatus.textContent = message;
      formStatus.className = kind ? `form-status ${kind}` : "form-status";
    };
    const onSubmit = async () => {
      const n = root.querySelector("#f-name").value.trim();
      const p = root.querySelector("#f-phone").value.trim();
      const enquiryType = root.querySelector("#f-enquiry").value;
      if (!n || !p || !enquiryType) {
        setFormStatus("Please fill in your name, phone, and enquiry type.", "error");
        return;
      }
      setFormStatus("Sending your details to the admin inbox...", "");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = "Sending...";
      }

      const formData = {
        name: n,
        phone: p,
        enquiry_type: enquiryType,
        time: new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
      };

      try {
        const response = await fetch(FORMSPREE_ENDPOINT, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error(`Formspree request failed with status ${response.status}`);
        }

        if (window.oaiq) {
          window.oaiq("measure", "registration_completed", { type: "customer_action" });
        }
        const fm = root.querySelector("#formMain");
        const fo = root.querySelector("#formOk");
        if (fm) fm.style.display = "none";
        if (fo) fo.style.display = "block";
        setFormStatus("Your admin has been notified.", "success");
      } catch (error) {
        console.error("Formspree submission failed:", error);
        setFormStatus("We could not send your details right now. Please try again.", "error");
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = 'Submit Your Request <span class="arrow">→</span>';
        }
      }
    };
    submitBtn && submitBtn.addEventListener("click", onSubmit);

    return () => {
      tBtn && tBtn.removeEventListener("click", onTheme);
      window.removeEventListener("scroll", onScroll);
      menuBtn && menuBtn.removeEventListener("click", openMM);
      closeMenu && closeMenu.removeEventListener("click", closeMM);
      mmLinks.forEach((a) => a.removeEventListener("click", closeMM));
      io.disconnect();
      cup.disconnect();
      tabHandlers.forEach(([t, h]) => t.removeEventListener("click", h));
      aSwitch && aSwitch.removeEventListener("click", onSwitch);
      qHandlers.forEach(([h, fn]) => h.removeEventListener("click", fn));
      submitBtn && submitBtn.removeEventListener("click", onSubmit);
    };
  }, []);

  return (
    <>
      <style>{CSS}</style>
      <div
        className="buildx-root"
        ref={rootRef}
        dangerouslySetInnerHTML={{ __html: BODY_HTML }}
      />
    </>
  );
}
